import React from 'react'

import { FinishExamButtonBox } from './FinishExamButtonBox/FinishExamButtonBox'
import { RegularButtonBox } from './RegularButtonBox/RegularButtonBox'

import { useAppDispatch, useAppSelector, useKeyDown } from 'common/hooks'
import { goToNextTask, goToPrevTask, selectResults } from 'features/exam'

type PropsType = {
  isAnswered: boolean
  isSelectedAnswers: boolean
  submitAnswerHandler: () => void
}

export const ButtonBox = (props: PropsType) => {
  const dispatch = useAppDispatch()
  const results = useAppSelector(selectResults)
  const isExamFinished = results.every(item => item.status !== null)

  useKeyDown(() => {
    dispatch(goToNextTask())
  }, 'ArrowRight')

  useKeyDown(() => {
    dispatch(goToPrevTask())
  }, 'ArrowLeft')

  return isExamFinished ? <FinishExamButtonBox /> : <RegularButtonBox {...props} />
}
